import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BellRing, ArrowRight, Upload } from "lucide-react";

export default function RappelDialog() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/rappels").then(({ data }) => {
      setItems(data);
      if (data.length > 0) setOpen(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToCourses = () => {
    setOpen(false);
    navigate("/cours");
  };

  if (!items || items.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="rounded-3xl max-w-lg p-0 overflow-hidden" data-testid="rappel-dialog">
        <div className="bg-gradient-to-br from-orange-500 to-orange-600 text-white px-7 py-6">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
              <BellRing className="h-6 w-6" />
            </div>
            <DialogHeader className="space-y-0 text-left">
              <DialogTitle className="font-display text-xl font-semibold text-white">Séances à rattraper</DialogTitle>
              <p className="text-orange-50 text-sm font-medium">
                Tu as manqué des séances. Dépose tes preuves + ta fiche d'autoévaluation pour les valider.
              </p>
            </DialogHeader>
          </div>
        </div>

        <div className="px-6 py-5 max-h-[55vh] overflow-y-auto space-y-3">
          {items.map((item) => (
            <button
              key={item.seance_id}
              onClick={goToCourses}
              data-testid={`rappel-item-${item.seance_id}`}
              className="w-full text-left rounded-2xl border border-slate-100 bg-slate-50 hover:bg-orange-50 hover:border-orange-200 transition-colors p-4 flex items-center gap-3"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-wide text-slate-400">
                  <span className="bg-white px-2 py-0.5 rounded-full">{item.bloc}</span>
                  <span className="bg-white px-2 py-0.5 rounded-full">{item.competency_code}</span>
                </div>
                <p className="font-bold text-slate-800 mt-1 truncate">Séance {item.order} · {item.title}</p>
              </div>
              <span className="inline-flex items-center gap-1 text-orange-600 font-bold text-sm shrink-0">
                <Upload className="h-4 w-4" /> Déposer
              </span>
            </button>
          ))}
        </div>

        <div className="px-6 py-4 border-t border-slate-100 flex items-center justify-between gap-3">
          <button onClick={() => setOpen(false)} data-testid="rappel-later" className="text-sm font-bold text-slate-400 hover:text-slate-600">Plus tard</button>
          <button onClick={goToCourses} data-testid="rappel-goto-cours" className="inline-flex items-center gap-1.5 text-sm font-bold text-orange-600 hover:text-orange-700">
            Aller à mes cours <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
